export const COUNTRY_CODE_MAX_LENGTH = 2;
